import { render, staticRenderFns } from "./EditSite.vue?vue&type=template&id=545daac9"
import script from "./EditSite.vue?vue&type=script&lang=js"
export * from "./EditSite.vue?vue&type=script&lang=js"
import style0 from "./EditSite.vue?vue&type=style&index=0&id=545daac9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports